// ==========================================================================
// components/ThemeDots.tsx — the colour dots: Rose, Lilac, Forest, Blue.
// Per login (FF-040; Blue FF-058). Moved out of AppShell on 10 Oct so the
// account menu and My profile can use it too.
// ==========================================================================
import { THEMES, useMembership, useSetTheme } from "@/lib/household";

export default function ThemeDots({ className = "", onPage = false, onPanel = false }: { className?: string; onPage?: boolean; onPanel?: boolean }) {
  const m = useMembership(); const set = useSetTheme();
  const cur = m.data?.theme ?? "rose";
  const size = onPage ? "h-9 w-9" : onPanel ? "h-4 w-4" : "h-7 w-7";
  const ring = onPanel ? "ring-offset-panel-raised ring-panel-ink" : "ring-offset-surface ring-ink";
  return (
    <div className={`flex shrink-0 items-center ${onPage ? "gap-4" : onPanel ? "gap-1.5" : "gap-2.5"} ${className}`}>
      {THEMES.map((t) => (
        <button key={t.key} type="button" title={t.label} aria-label={`${t.label} colours`} aria-pressed={cur === t.key} onClick={() => set.mutate(t.key)}
          className={`${size} ${ring} rounded-full ring-offset-2 transition ${cur === t.key ? "ring-2" : "opacity-80 hover:opacity-100"}`} style={{ background: t.swatch }} />
      ))}
    </div>
  );
}
